import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, LockIcon } from 'lucide-react';
export function OfferBlock() {
  return <section id="offer" className="py-32 px-6 relative overflow-hidden" data-id="element-115">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/5 blur-[150px] rounded-full pointer-events-none" data-id="element-116" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/[0.03] border border-gold-500/30 rounded-[2.5rem] p-8 md:p-16 text-center backdrop-blur-md shadow-[0_0_50px_rgba(212,160,23,0.05)]" data-id="element-118">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white" data-id="element-119">
            No dejes que tu primer cheque sea el inicio de una vida de deudas.
          </h2>

          <p className="text-xl text-gray-400 mb-12" data-id="element-120">
            Obtén el sistema completo de Generación Wealth y rompe el ciclo
            financiero de tu familia hoy mismo.
          </p>

          <div className="inline-block mb-10" data-id="element-121">
            <div className="text-sm font-bold tracking-widest text-gold-400 uppercase mb-2" data-id="element-122">
              Inversión única
            </div>
            <div className="text-6xl md:text-7xl font-display font-bold text-white flex items-start justify-center" data-id="element-123">
              <span className="text-3xl mt-2 mr-1" data-id="element-124">$</span>
              8.00
              <span className="text-2xl mt-auto mb-2 ml-2 text-gray-500" data-id="element-125">
                USD
              </span>
            </div>
          </div>

          <button className="w-full md:w-auto group relative inline-flex items-center justify-center gap-3 px-10 py-5 bg-gold-500 text-dark font-bold text-xl rounded-full overflow-hidden transition-transform hover:scale-105 hover:shadow-[0_0_40px_rgba(212,160,23,0.5)] mb-6" data-id="element-126">
            <span className="relative z-10 flex items-center gap-2" data-id="element-127">
              DESCARGA TU PDF AHORA
              <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-128" />
            </span>
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-129" />
          </button>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-130">
            <LockIcon className="w-4 h-4" data-id="element-131" />
            <span data-id="element-132">
              Blindaje instantáneo. Descarga inmediata para tu futuro.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}